const initState = {
    currentCountry: 'india',
    currentCountryData: null,
		allData: [],
		indiaStatesData: [],
		districtsData: []
  };
  
  const reducer = (state = initState, action) => {
    // console.log(action);
    switch (action.type) {
      case "DATA":
        return {
          ...state,
          allData: action.data
        };
      case "COUNTRY":
        return {
          ...state,
          currentCountry: action.data
        };
      case "COUNTRY_DATA":
        return {
          ...state,
          currentCountryData: action.data
				};
			case "INDIA_STATES_DATA":
				return {
					...state,
					indiaStatesData: action.data
				};
			case "DISTRICTS_DATA":
				return {
					...state,
					districtsData: action.data
				};
      default:
        return state;
    }
  };
  
  export default reducer;